<template>
  <div class="add-step">
    <ins-header
      :title="headerTitle"
      :hasVerifi="false"
      @back="goBack"
    ></ins-header>
    <div class="add-card">
      <table class="setting-table">
        <tr>
          <td>
            <input
              type="checkbox"
              id="switchNotification"
              v-model="notificationSetting.push_notification"
              @change="pushChenge"
            /><label for="switchNotification"></label>
          </td>
          <td>پوش نوتیفیکیشن</td>
          <td>
            <img src="@/assets/icons/notification.svg" />
          </td>
        </tr>
        <tr>
          <td>
            <input
              type="checkbox"
              id="switchEmail"
              v-model="notificationSetting.email"
              @change="emailChenge"
            /><label for="switchEmail"></label>
          </td>
          <td>آگاه سازی با پست الکترونیکی</td>
          <td>
            <img src="@/assets/icons/letter.svg" />
          </td>
        </tr>
        <tr>
          <td>
            <input
              type="checkbox"
              id="switchSms"
              v-model="notificationSetting.sms"
              @change="smsChenge"
            /><label for="switchSms"></label>
          </td>
          <td>آگاه سازی پیامکی</td>
          <td>
            <img src="@/assets/icons/sms.svg" />
          </td>
        </tr>
      </table>
    </div>
    <Modal v-model="isShow" :close="closeModal">
      <div class="modal">
        <h4>فعال سازی آگاهی سازی پیامکی</h4>
        <p>
          با تایید این پیام، مبلغ ۱۰ هزار تومان به صورت ماهانه به عنوان آبونمان
          از حساب شما کسر می‌گردد.
        </p>
        <button class="m-btn" @click="closeModal">متوجه شدم</button>
      </div>
    </Modal>
  </div>
</template>

<script>
import InsHeader from "../../layouts/inside-header.vue";
export default {
  components: {
    InsHeader,
  },
  mounted() {
    this.getData();
  },
  computed: {
    headerTitle() {
      return this.$route.meta.prtitle;
    },
  },
  data() {
    return {
      isShow: false,
      notificationSetting: {},
      userId: null,
    };
  },
  methods: {
    getData() {
      this.$store.dispatch("user/getNotificationSettingList").then((rspon) => {
        this.userId = rspon.id;

        this.$store
          .dispatch("user/getNotificationSetting", this.userId)
          .then((rsp) => {
            this.notificationSetting = rsp;
          });
      });
    },
    smsChenge() {
      if (this.notificationSetting.sms == true) {
        this.isShow = true;
      }
      var data = {
        data: {
          sms: this.notificationSetting.sms,
        },
        pk: this.userId,
      };
      this.$store
        .dispatch("user/updateNotificationSetting", data)
        .then((rsp) => {
          this.notificationSetting = rsp;
        });
    },
    pushChenge() {
      var data = {
        data: {
          push_notification: this.notificationSetting.push_notification,
        },
        pk: this.userId,
      };
      this.$store
        .dispatch("user/updateNotificationSetting", data)
        .then((rsp) => {
          this.notificationSetting = rsp;
        });
    },
    emailChenge() {
      var data = {
        data: {
          email: this.notificationSetting.email,
        },
        pk: this.userId,
      };
      this.$store
        .dispatch("user/updateNotificationSetting", data)
        .then((rsp) => {
          this.notificationSetting = rsp;
        });
    },
    closeModal() {
      this.isShow = false;
    },
    goBack() {
      this.$router.back();
    },
  },
};
</script>

<style scoped>
label {
  cursor: pointer;
  text-indent: -9999px;
  width: 40px;
  height: 20px;
  background: grey;
  display: block;
  border-radius: 100px;
  position: relative;
  margin-top: -15px;
}
.modal {
  width: 300px;
  padding: 30px;
  box-sizing: border-box;
  background-color: #fff;
  font-size: 20px;
  text-align: center;
}
.modal h4 {
  margin-bottom: 10px;
}
.modal p {
  margin-bottom: 24px;
  font-size: 15px;
}
</style>
